import { FormControlLabel, Checkbox } from "@mui/material";
import { useFormContext, useController } from "react-hook-form";

import { useTranslations } from "@fenetech/translations";

import { IQuotePermissions } from "helpers/interfaces";

interface IProps {
    permissions?: IQuotePermissions
}

function SelectIsAddressSameAsShipping({ permissions } : IProps) {

    const tm = useTranslations();
    const name ="billing.isAddressSameAsShipping"
    const { control } = useFormContext();
    const { field } = useController({
        name: name,
        control: control,
     });

    return <>
        <FormControlLabel 
            control={
                <Checkbox 
                    onChange={field.onChange}
                    onBlur={field.onBlur}
                    ref={field.ref}
                    checked={field.value}
                    disabled={!permissions?.billingAddress ?? true}
                />} 
            label={tm.Get("Same as shipping address")} 
        />    
    </>

}

export default SelectIsAddressSameAsShipping;